// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verifyMapping-wrapper {
  padding: 0 36px;
  width: 100%;
}
.verifyMapping--contents {
  background: #fff;
}
.verifyMapping--headingButtonWrapper {
  padding: 19px 24px;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #edf0f2;
}
.verifyMapping--headingLockUnlock {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.verifyMapping--lockUnlock {
  height: 36px;
  width: 36px;
  justify-content: center;
  align-items: center;
  display: flex;
  display: -webkit-flex;
  margin-left: 10px;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
}
.verifyMapping--lock {
  background: #ffe4e3;
}
.verifyMapping--unlock {
  background: #e5f1f8;
}
.verifyMapping--carrierName {
  background: #f8f9fa;
  padding: 12px 22px;
}
.verifyMapping--carrierFieldsWrapper {
  padding: 20px 22px;
}
.verifyMapping--actionBtn {
  font-size: 14px;
  font-weight: 500;
  padding: 8px 20px;
  margin-left: 15px;
}
.verifyMapping--carrierFieldsWrapper .field-label sup {
  color: #c91b1b;
}
.verifyMapping--carrierFieldsWrapper .flex {
  justify-content: flex-start;
}
.verifyMapping--cpwFieldLabel {
  line-height: 1;
  font-size: 14px;
  color: #1984bc;
}
.verifyMapping--contents .pagination--wrapper .pagination--info {
  width: 20%;
}
.verifyMapping--contents .pagination--wrapper .pagination {
  width: 80%;
}
.verifyMapping--contents .pagination--numbersWrapper {
  max-width: calc(100% - 90px);
  display: flex;
  overflow-x: auto;
}
.verifyMapping--fields {
  width: 100%;
  padding-right: 40px;
  position: relative;
}
.verifyMapping--carrierFieldsWrapper .addFieldButton {
  position: absolute;
  right: 0;
  bottom: 13px;
}
.verifyMapping--dropdownFields {
  width: calc(25% - 30px);
}
.verifyMapping--addMore {
  position: relative;
}
.verifyMapping--deleteAddMore {
  position: absolute;
  right: -35px;
  top: 25px;
}
.button--disable {
  pointer-events: none;
  opacity: 0.7;
}
.button--disable.carrierUploadFormDropdown--btn {
  background: #f1f4f6;
  border: 1px solid #d6d6d6;
}
.verifyMapping--carrierFieldsWrapper p {
  font-size: 14px;
}
.verifyMapping--toolTip {
  background: #3c3838;
  color: #fff;
  font-size: 12px;
  border-radius: 4px;
  padding: 7px 10px;
  position: absolute;
  left: 50%;
  top: -35px;
  width: 315px;
  transform: translateX(-50%);
  text-align: center;
  display: none;
}
.verifyMapping--toolTipArrow {
  content: '';
  border-top: 5px solid #3c3838;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  position: absolute;
  left: 50%;
  bottom: -5px;
  margin-left: -4px;
}
.verifyMapping--lockUnlock:hover .verifyMapping--toolTip {
  display: block;
}
.verifyMapping--lockUnlock__disable {
  cursor: not-allowed;
}
.carrierUploadFormDropdown--search {
  padding: 0 10px;
}
.verifyMapping--fields .carrierUploadFormDropdown--content {
  max-height: 350px;
}
.verifyMapping--headingLockUnlock h2 {
  font-size: 20px;
}
.verifyMapping--fields .verifyMapping--deleteAddMore {
  position: static;
  width: 40px;
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/carrierOnboard/verifymapping/verifyMapping.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,WAAW;EACX,6BAA6B;EAC7B,kCAAkC;EAClC,mCAAmC;EACnC,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".verifyMapping-wrapper {\n  padding: 0 36px;\n  width: 100%;\n}\n.verifyMapping--contents {\n  background: #fff;\n}\n.verifyMapping--headingButtonWrapper {\n  padding: 19px 24px;\n  display: flex;\n  display: -webkit-flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #edf0f2;\n}\n.verifyMapping--headingLockUnlock {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  justify-content: center;\n}\n.verifyMapping--lockUnlock {\n  height: 36px;\n  width: 36px;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  display: -webkit-flex;\n  margin-left: 10px;\n  border-radius: 6px;\n  cursor: pointer;\n  position: relative;\n}\n.verifyMapping--lock {\n  background: #ffe4e3;\n}\n.verifyMapping--unlock {\n  background: #e5f1f8;\n}\n.verifyMapping--carrierName {\n  background: #f8f9fa;\n  padding: 12px 22px;\n}\n.verifyMapping--carrierFieldsWrapper {\n  padding: 20px 22px;\n}\n.verifyMapping--actionBtn {\n  font-size: 14px;\n  font-weight: 500;\n  padding: 8px 20px;\n  margin-left: 15px;\n}\n.verifyMapping--carrierFieldsWrapper .field-label sup {\n  color: #c91b1b;\n}\n.verifyMapping--carrierFieldsWrapper .flex {\n  justify-content: flex-start;\n}\n.verifyMapping--cpwFieldLabel {\n  line-height: 1;\n  font-size: 14px;\n  color: #1984bc;\n}\n.verifyMapping--contents .pagination--wrapper .pagination--info {\n  width: 20%;\n}\n.verifyMapping--contents .pagination--wrapper .pagination {\n  width: 80%;\n}\n.verifyMapping--contents .pagination--numbersWrapper {\n  max-width: calc(100% - 90px);\n  display: flex;\n  overflow-x: auto;\n}\n.verifyMapping--fields {\n  width: 100%;\n  padding-right: 40px;\n  position: relative;\n}\n.verifyMapping--carrierFieldsWrapper .addFieldButton {\n  position: absolute;\n  right: 0;\n  bottom: 13px;\n}\n.verifyMapping--dropdownFields {\n  width: calc(25% - 30px);\n}\n.verifyMapping--addMore {\n  position: relative;\n}\n.verifyMapping--deleteAddMore {\n  position: absolute;\n  right: -35px;\n  top: 25px;\n}\n.button--disable {\n  pointer-events: none;\n  opacity: 0.7;\n}\n.button--disable.carrierUploadFormDropdown--btn {\n  background: #f1f4f6;\n  border: 1px solid #d6d6d6;\n}\n.verifyMapping--carrierFieldsWrapper p {\n  font-size: 14px;\n}\n.verifyMapping--toolTip {\n  background: #3c3838;\n  color: #fff;\n  font-size: 12px;\n  border-radius: 4px;\n  padding: 7px 10px;\n  position: absolute;\n  left: 50%;\n  top: -35px;\n  width: 315px;\n  transform: translateX(-50%);\n  text-align: center;\n  display: none;\n}\n.verifyMapping--toolTipArrow {\n  content: '';\n  border-top: 5px solid #3c3838;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  position: absolute;\n  left: 50%;\n  bottom: -5px;\n  margin-left: -4px;\n}\n.verifyMapping--lockUnlock:hover .verifyMapping--toolTip {\n  display: block;\n}\n.verifyMapping--lockUnlock__disable {\n  cursor: not-allowed;\n}\n.carrierUploadFormDropdown--search {\n  padding: 0 10px;\n}\n.verifyMapping--fields .carrierUploadFormDropdown--content {\n  max-height: 350px;\n}\n.verifyMapping--headingLockUnlock h2 {\n  font-size: 20px;\n}\n.verifyMapping--fields .verifyMapping--deleteAddMore {\n  position: static;\n  width: 40px;\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
